import { render, staticRenderFns } from "./StudentNotesTab.vue?vue&type=template&id=630955a6&"
import script from "./StudentNotesTab.vue?vue&type=script&lang=js&"
export * from "./StudentNotesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports